import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { PublicModule } from '@entities/PublicModule';
import { buildLibraryItemPath } from '@shared/config';
import { ModuleAuthor } from './ModuleAuthor';

interface PublicModuleCardProps {
  module: PublicModule;
  added: boolean;
  adding: boolean;
  onAdd: (module: PublicModule) => void;
}

/** Карточка модуля в каталоге: открывается целиком, «Добавить» — без перехода. */
export function PublicModuleCard({ module: m, added, adding, onAdd }: PublicModuleCardProps) {
  const { t } = useTranslation();
  const role = `${t(m.isOfficial ? 'library.role.official' : 'library.role.community')} · ${t('library.installCount', { count: m.installs })}`;

  return (
    <article className="lb-card">
      <div className="lb-card-meta">
        {m.cefrLevel && <span className="lb-level-chip">{m.cefrLevel}</span>}
        <span>{t('library.cardCount', { count: m.cards.length })}</span>
      </div>
      <h3 className="lb-card-title">
        <Link to={buildLibraryItemPath(m.id)} className="lb-card-link">{m.name}</Link>
      </h3>
      {m.description && <p className="lb-card-desc">{m.description}</p>}
      <div className="lb-card-foot">
        <ModuleAuthor name={m.author} official={m.isOfficial} role={role} />
        <button
          type="button"
          className="lb-add"
          data-added={added}
          aria-busy={adding}
          aria-label={added ? undefined : t('library.addNamed', { name: m.name })}
          disabled={added || adding}
          onClick={() => onAdd(m)}
        >
          {added ? t('library.addedShort') : adding ? '…' : t('library.add')}
        </button>
      </div>
    </article>
  );
}
